import { getFixedNumber, groupBy } from "../../../../components/Common/CommonFunction";
import { numberWithCommas } from "../../../../Reports/Report_common_function";


export const columns_1 = [
    "Document No",
    "Advance Amount",
    "Net Amount",
    "Payment Mode1",
    "Payment Mode1 Amount",
    "Payment Mode2",
    "Payment Mode2 Amount"
];


export const columns_2 = [
    "Invoice",
    "Advance Amount",
    "Net Amount",
    "Total",
    "Payment Mode1",
    "Payment Mode1 Amount",
    "Payment Mode2",
    "Payment Mode2 Amount"
];




export const PageHedercolumns = [
    "Billed by",
    "Billed to",
    ''
]
export const Footercolumn = [
    "",
]

export const BilledBy = [
    "Billed by",
]
export const BilledTo = [
    "Billed by",
]
export const DetailsOfTransport = [
    "Billed by",
]


export const Rows_1 = (data) => {

    let finalOrderAmount = 0
    let finalOrderAdvanceAmount = 0

    const returnArr = []

    // SECTION TITLE
    returnArr.push([
        `Order`,
        ``,
        ``,
        ``,
        ``,
        ``,
        ``,
        ``
    ]);

    const groupedData = {}

    // 1️⃣ GROUPING BY DATE
    data.OrderData.forEach((element) => {
        if (element.FullOrderNumber === "Total") return;

        const date = element.OrderDate;

        const row = [
            `${element.FullOrderNumber}`,                              // Document No
            `${getFixedNumber(element.AdvanceAmount, 2).toFixed(2)}`,   // Advance
            `${getFixedNumber(element.OrderAmount, 2).toFixed(2)}`,      // Net Amount
            `${element.PaymentMode1Name || ""}`,                         // PM1
            `${element.PaymentMode1Amount || ""}`,                       // PM1 Amt
            `${element.PaymentMode2Name || ""}`,                         // PM2
            `${element.PaymentMode2Amount || ""}`                        // PM2 Amt
        ];
        

        finalOrderAmount += getFixedNumber(element.OrderAmount, 2);
        finalOrderAdvanceAmount += getFixedNumber(element.AdvanceAmount, 2);

        if (!groupedData[date]) groupedData[date] = [];
        groupedData[date].push(row);
    });

    // 2️⃣ PUSH GROUPED ROWS
    Object.keys(groupedData).sort().forEach(date => {
        returnArr.push(...groupedData[date]);
    });

    // 3️⃣ ORDER TOTAL ROW
    if (returnArr.length > 0) {
        returnArr.push([
            `Order Total`,
            `${numberWithCommas(finalOrderAdvanceAmount.toFixed(2))}`,
            `${numberWithCommas(finalOrderAmount.toFixed(2))}`,
            "",
            "",
            "",
            ""
        ]);
        
    }

    // 4️⃣ PAYMENT MODE SUMMARY
    const orderModeSummary = {}

    // data.OrderData.forEach(o => {
    //     if (o.FullOrderNumber === "Total") return;

    //     const pm1 = o.PaymentMode1Name;
    //     const pm1Amt = Number(o.PaymentMode1Amount) || 0;

    //     const pm2 = o.PaymentMode2Name;
    //     const pm2Amt = Number(o.PaymentMode2Amount) || 0;

    //     if (pm1) {
    //         if (!orderModeSummary[pm1]) {
    //             orderModeSummary[pm1] = { pm1Total: 0, pm2Total: 0 };
    //         }
    //         orderModeSummary[pm1].pm1Total += pm1Amt;
    //     }

    //     if (pm2) {
    //         if (!orderModeSummary[pm2]) {
    //             orderModeSummary[pm2] = { pm1Total: 0, pm2Total: 0 };
    //         }
    //         orderModeSummary[pm2].pm2Total += pm2Amt;
    //     }
    // });


    const getSingleSummaryText = (list) => {
        const summary = {};
    
        list.forEach(item => {
            const pm1 = item.PaymentMode1Name;
            const pm2 = item.PaymentMode2Name;
    
            const pm1Amt = Number(item.PaymentMode1Amount) || 0;
            const pm2Amt = Number(item.PaymentMode2Amount) || 0;
    
            if (pm1) {
                if (!summary[pm1]) summary[pm1] = 0;
                summary[pm1] += pm1Amt;
            }
    
            if (pm2) {
                if (!summary[pm2]) summary[pm2] = 0;
                summary[pm2] += pm2Amt;
            }
        });
    
        return Object.keys(summary)
            .map(m => `${m} = ${summary[m].toFixed(2)}`)
            .join(", ");   // <-- STRING RETURN
    };
    

   
 // ORDER SINGLE SUMMARY ROW
 returnArr.push([ "Order Payment Mode Total", "", "", "", "", "", "" ]);

 returnArr.push([
     getSingleSummaryText(data.OrderData),  // STRING ONLY
     "", "", "", "", "", ""
 ]);
 
 

    // SUMMARY ITEMS
    Object.keys(orderModeSummary).forEach(mode => {
        returnArr.push([
            mode,
            "",
            "",
            "",
            numberWithCommas(orderModeSummary[mode].pm1Total.toFixed(2)),
            "",
            numberWithCommas(orderModeSummary[mode].pm2Total.toFixed(2)),
        ]);
        
    });

    // GAP ROW
    returnArr.push(["___BLANK_FULL_ROW___"]);

    return returnArr;
}



export const Row_2 = (data) => {

    let finalInvoiceAmount = 0;
    let finalInvoiceAdvanceAmount = 0;

    const returnArr = [];

    // SECTION TITLE (same as Order: "Order")
    returnArr.push([
        `Invoice`,
        ``,
        ``,
        ``,
        ``,
        ``,
        ``,
        ``
    ]);

    // ===== GROUP BY DATE (same Order logic) =====
    const groupedData = {};

    data.InvoiceData.forEach((element) => {
        if (element.FullInvoiceNumber === "Total") return;

        const date = element.InvoiceDate;  // <-- adjust field name if needed

        const row = [
            `${element.FullInvoiceNumber}`,
            `${getFixedNumber(element.AdvanceAmount, 2).toFixed(2)}`,
            `${getFixedNumber(element.GrandTotal, 2).toFixed(2)}`,
            `${getFixedNumber(element.TotalAmount, 2).toFixed(2)}`,
            `${element.PaymentMode1Name || ""}`,
            `${element.PaymentMode1Amount || ""}`,
            `${element.PaymentMode2Name || ""}`,
            `${element.PaymentMode2Amount || ""}`
        ];

        finalInvoiceAmount += getFixedNumber(element.GrandTotal, 2);
        finalInvoiceAdvanceAmount += getFixedNumber(element.AdvanceAmount, 2);

        if (!groupedData[date]) groupedData[date] = [];
        groupedData[date].push(row);
    });

    // push grouped rows (sorted by date)
    Object.keys(groupedData).sort().forEach(date => {
        returnArr.push(...groupedData[date]);
    });

    // ===== INVOICE TOTAL (like Order Total) =====
    returnArr.push([
        `Invoice Total`,
        `${numberWithCommas(finalInvoiceAdvanceAmount.toFixed(2))}`,
        `${numberWithCommas(finalInvoiceAmount.toFixed(2))}`,
        `${numberWithCommas((finalInvoiceAdvanceAmount + finalInvoiceAmount).toFixed(2))}`,
        ``,
        ``,
        ``,
        ``
    ]);

    // ===== PAYMENT MODE SUMMARY (same as Order logic) =====
    const modeSummary = {};

    const getSingleSummaryText = (list) => {
        const summary = {};
    
        list.forEach(item => {
            const pm1 = item.PaymentMode1Name;
            const pm2 = item.PaymentMode2Name;
    
            const pm1Amt = Number(item.PaymentMode1Amount) || 0;
            const pm2Amt = Number(item.PaymentMode2Amount) || 0;
    
            if (pm1) {
                if (!summary[pm1]) summary[pm1] = 0;
                summary[pm1] += pm1Amt;
            }
    
            if (pm2) {
                if (!summary[pm2]) summary[pm2] = 0;
                summary[pm2] += pm2Amt;
            }
        });
    
        return Object.keys(summary)
            .map(m => `${m} = ${summary[m].toFixed(2)}`)
            .join(", ");   // <-- STRING RETURN
    };
    
    
    // Payment summary header
   // INVOICE SINGLE SUMMARY ROW
   returnArr.push([ "Invoice Payment Mode Total", "", "", "", "", "", "", "" ]);

   returnArr.push([
       getSingleSummaryText(data.InvoiceData),
       "", "", "", "", "", ""
   ]);
   

    // Payment summary rows
    Object.keys(modeSummary).forEach((mode) => {
        returnArr.push([
            `${mode}`,
            "",
            "",
            "",
            "",
            numberWithCommas(modeSummary[mode].pm1Total.toFixed(2)),
            "",
            numberWithCommas(modeSummary[mode].pm2Total.toFixed(2))
        ]);
    });

    // Blank separator row (same as Order)
    returnArr.push(["___BLANK_FULL_ROW___"]);

    return returnArr;
};


export const ReportFotterColumns = [
    "SGST",
    "CGST", "Quantity",
    "GST % ",
    "TaxbleAmt.", "IGST", "Total Amt"
];

export const ReportFotterColumns2 = [
    "SGST",
];

export const ReportRows = (data, doc) => {

    const terms = data.OrderTermsAndCondition
    const slicedArray = terms?.slice(0, 2);
    var TableArray = [["Terms And Condition"],
    [`${slicedArray?.[0] === undefined ? "" : slicedArray[0]?.TermsAndCondition}`,
    ],
    [`${slicedArray?.[1] === undefined ? "" : slicedArray[1]?.TermsAndCondition}`,
    ],
    ]
    return TableArray
}

export const BilledByRow = (data) => {
    var BilledByArray = [
        [`                  ${data.SupplierName}`],
        [`                ${(data.GSTIN === null || data.GSTIN === undefined) ? "" : data.GSTIN}`],
        [`                ${data.Date}`],
    ]
    return BilledByArray;
}











